'use client';

import { c as _c } from "react/compiler-runtime";
import { useUser } from '@clerk/nextjs';
import { isClaiStaff } from '@lib/auth/utils/is-clai-staff';

/**
 * Returns true when the signed-in user is a verified @goclai.com staff member.
 * Falls back to false while loading or when the user is signed out.
 */
export function useIsClaiStaff() {
  const $ = _c(2);
  const {
    isLoaded,
    user
  } = useUser();
  if (!isLoaded || !user) {
    return false;
  }
  let t0;
  if ($[0] !== user) {
    t0 = isClaiStaff(user);
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}